module.exports = __webpack_public_path__ + "img/bg4.2be7a9a8.webp";